
import { createContext, useState, useEffect, useContext, useCallback } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../Redux/user/user";
import { getFormationPositions } from "../api/squadManager/getFormationPositions";

export const FormationPositionsContext = createContext({
    formationPositions: null,
    positionsForFormation: () => null,
    variantsForFormation: () => null,
});

const FormationPositionsServiceProvider = ({ children }) => {

    const [formationPositions, setFormationPositions] = useState(null);

    const user = useSelector(selectUser);

    const loadFormationPositions = useCallback(async (callbackError) => {
        try {
            await getFormationPositions(
                function (response) {
                    setFormationPositions(response.data.formation_positions);
                },
                function (error) {
                    callbackError(error);
                }
            );
        } catch (err) {
            callbackError(err);
        }
    });

    // Aliases are resolved server side, so look the formation up directly.
    // The entry is an array on older backends and {positions, variants} on newer ones.
    const entryForFormation = useCallback((formation) => {
        if (!formation || !formationPositions) {
            return null;
        }

        return formationPositions[formation] ?? null;
    }, [formationPositions]);

    const positionsForFormation = useCallback((formation) => {
        const entry = entryForFormation(formation);

        if (!entry) {
            return null;
        }

        return Array.isArray(entry) ? entry : entry.positions ?? null;
    }, [entryForFormation]);

    // Null switches the count check off. An older backend sends no variants, and a
    // formation we cannot count is one we must not block on.
    const variantsForFormation = useCallback((formation) => {
        const entry = entryForFormation(formation);

        if (!entry || Array.isArray(entry)) {
            return null;
        }

        return entry.variants ?? null;
    }, [entryForFormation]);

    useEffect(() => {
        if (!user) {
            return
        }
        if (formationPositions) {
            return
        }
        loadFormationPositions((error) => {
            console.log(error)
        })
    }, [user]);

    return (
        <FormationPositionsContext.Provider value={{
            formationPositions,
            positionsForFormation,
            variantsForFormation
        }}>
            {children}
        </FormationPositionsContext.Provider>
    );
};

export const useFormationPositionsContext = () => useContext(FormationPositionsContext);

export default FormationPositionsServiceProvider;
